import { BASE_URL, DEFAULT_SOCIAL_IMAGE, getCanonicalUrl, slugToLabel } from "./seo.js";

export const PERSON_ID = `${BASE_URL}/#person`;
export const BUSINESS_ID = `${BASE_URL}/#business`;
export const STRUCTURED_DATA_CONTEXT = "https://schema.org";

export const HEJ_MAMMA_FIXED_IMAGES = [
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769392445-n2en2.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769382087-aaenlc.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769402788-hd98xf.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769389416-ilpwp.jpg",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769425729-eex4he.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764845387986-lp5ji.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769793871-dri2h.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769409518-c5z6gs.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769513999-5cicwh.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/hej-mamma/1764769604970-wfiys.jpg",
];

export const HEJ_MAMMA_FAQ_ITEMS = [
  {
    question: "Jag känner mig obekväm framför kameran – blir det bra ändå?",
    answer:
      'Ja, absolut. Nästan alla jag fotar säger så innan! Jag guidar dig genom hela sessionen och fokuserar på rörelse och känsla snarare än stela poser. Du behöver inte kunna "posera" – det räcker att du är du.',
  },
  {
    question: "Jag känner mig inte tillräckligt snygg just nu. Därför väntar jag med att boka.",
    answer:
      "Precis så kände jag under hela min mammaledighet. Jag ville helst inte vara med på bild och tyckte att jag blev ful på alla bilder. Men nu några år senare när jag ser tillbaka på de bilder jag har är jag otroligt tacksam över att de finns. Ibland är det trötthet och hormoner som lurar, för jag kan inte alls se nu att jag såg så sliten ut som jag kände mig just då. Du kommer ångra dig om du väljer bort att vara med på bild med dina barn på grund av det.",
  },
  {
    question: "Fotograferar du bara mammor med barn?",
    answer:
      "Nej – du kan boka en session bara för dig själv, tillsammans med ditt barn eller hela familjen. Fokus ligger på dig som mamma, i den form som känns rätt för dig.",
  },
  {
    question: "Måste det vara fint och städat hemma? Eller vara bra ljus?",
    answer:
      "Nej, inte alls. Jag hittar alltid vinklar och ljus som fungerar. Om ljuset inte räcker till fotograferar jag med en liten blixt. Det handlar mer om känslan än om perfekta ytor – ibland är det just det röriga, eller det lilla ljusstråket genom fönstret, som gör bilden intressant.",
  },
  {
    question: "När är bästa tiden att fotografera?",
    answer: "Året runt går bra då vi fotar inomhus i hemmet. Har du egen plats du vill fota på utomhus går det självklart bra!",
  },
  {
    question: "Mina barn är livliga – blir det ens några bra bilder?",
    answer:
      "Ja, absolut. Jag jobbar utifrån barnens energi, inte emot den. Vi låter dem vara som de är, det blir alltid något fint, oavsett. Vissa barn är med på några bilder, andra är med hela fotograferingen.",
  },
  {
    question: "Behöver jag förbereda något innan fotograferingen?",
    answer:
      "Nej, om det är något vi behöver flytta på i hemmet gör jag det på plats. Att ge barnen något att äta innan så att de inte är hungriga kan alltid vara bra.",
  },
  {
    question: "Vad ska jag ha på mig?",
    answer:
      "Det viktigaste är att du känner dig fin och bekväm! Vill du att jag hjälper dig att välja kläder innan går det bra. Det finns tid för 2 ombyten. Om du är gravid fungerar det alltid fint med en skjorta eller blus som du kan knäppa upp så att magen syns.",
  },
  {
    question: "Vad kostar en fotografering?",
    answer:
      "Från 4 200 kr. Då ingår fotografering (ca 1 timme) och 5 redigerade digitala bilder. Stora paketet med ca 50 bilder kostar 7 500 kr, och Dubbel-paketet med två fototillfällen (gravid + bebis) och 10 bilder kostar 7 900 kr. Vid fotografering på helg tillkommer 1 000 kr. Du kan välja paket efter att du sett bilderna.",
  },
  {
    question: "När under graviditeten är det bäst att fotografera?",
    answer:
      "Oftast runt vecka 30–36, då magen syns ordentligt och du fortfarande orkar röra dig. Det går lika bra tidigare eller senare om det passar dig bättre, så hör av dig när det känns rätt. Väljer du Dubbel-paketet ses vi först när du är gravid och igen när bebisen är här.",
  },
];

export const WEDDING_FEATURED_IMAGES = [
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/wedding/1768315038419-xu7gba.webp",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/wedding/1768380711274-886uya.jpeg",
  "https://xgeqhjldjvmeazghppik.supabase.co/storage/v1/object/public/portfolio-images/wedding/1768311877933-94cxf.jpeg",
];

export const WEDDING_FAQ_ITEMS = [
  {
    question: "Hur lång tid i förväg bör vi boka?",
    answer:
      "Jag rekommenderar att boka så tidigt som möjligt, gärna 6-12 månader innan bröllopet. Populära datum bokas snabbt, särskilt under sommarmånaderna.",
  },
  {
    question: "Kan vi träffas innan bröllopet?",
    answer:
      "Absolut! Alla mina paket inkluderar ett planeringsmöte där vi går igenom dagen tillsammans. Heldagspaketet inkluderar även en provfotografering 1-2 månader innan.",
  },
  {
    question: "Hur många bilder får vi?",
    answer:
      "Ni får minst 50 redigerade bilder per timme som jag fotograferat. Det innebär ca 500+ bilder för en heldag och ca 250+ bilder för en halvdag.",
  },
  {
    question: "När får vi bilderna?",
    answer:
      "Ni får era bilder inom 6-8 veckor efter bröllopet. Ni får tillgång till ett personligt webbgalleri där ni kan ladda ner bilderna och dela med gäster.",
  },
  {
    question: "Fotograferar du utanför Stockholm?",
    answer:
      "Ja, jag reser gärna! För heldagspaketet ingår resa och boende. För halvdags- och 3-timmarspaket tillkommer kostnad för resa och eventuellt boende utanför Stockholm.",
  },
  {
    question: "Vad händer om det regnar?",
    answer:
      "Regn kan faktiskt ge fantastiska bilder! Men vi anpassar oss alltid efter vädret och hittar fina platser oavsett väderlek. Det viktigaste är att ni är avslappnade och njuter av dagen.",
  },
];

const normalizeText = (value) => (value || "").replace(/\s+/g, " ").trim();

const dedupe = (items) => Array.from(new Set(items.filter(Boolean)));

const toListItems = (items = []) =>
  items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    url: item.url,
    name: item.name,
    image: item.image,
  }));

const toFaqItems = (faqItems = []) =>
  faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  }));

export const serializeJsonLd = (jsonLd) => {
  if (!jsonLd) {
    return "";
  }

  const payload = Array.isArray(jsonLd)
    ? {
        "@context": STRUCTURED_DATA_CONTEXT,
        "@graph": jsonLd,
      }
    : {
        "@context": STRUCTURED_DATA_CONTEXT,
        ...jsonLd,
      };

  return JSON.stringify(payload).replace(/</g, "\\u003c");
};

export const buildHomeJsonLd = (homeImages = []) => {
  const websiteSchema = {
    "@type": "WebSite",
    name: "Ina Nederdal Fotograf",
    url: BASE_URL,
    publisher: {
      "@id": BUSINESS_ID,
    },
  };

  if (homeImages.length === 0) {
    return [websiteSchema];
  }

  return [
    websiteSchema,
    {
      "@type": "ImageGallery",
      name: "Ina Nederdal - Portfolio",
      description:
        "Porträtt- och lifestyle-fotografering av Ina Nederdal i Stockholm. Mammaporträtt, gravidfoto, familjebilder och bröllop.",
      url: BASE_URL,
      author: {
        "@id": PERSON_ID,
      },
      image: homeImages.slice(0, 12).map((image, index) => ({
        "@type": "ImageObject",
        url: image.url,
        name: normalizeText(image.caption) || `Portfolio bild ${index + 1}`,
        author: {
          "@id": PERSON_ID,
        },
      })),
    },
  ];
};

export const buildAboutJsonLd = ({ image = DEFAULT_SOCIAL_IMAGE } = {}) => ({
  "@type": "Person",
  "@id": PERSON_ID,
  name: "Ina Nederdal",
  jobTitle: ["Photographer", "Fotograf"],
  url: BASE_URL,
  image,
  email: "ina.nederdal@gmail.com",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Stockholm",
    addressCountry: "SE",
  },
  sameAs: ["https://www.instagram.com/inaouti", "https://www.linkedin.com/in/ina-nederdal-394233186/"],
  worksFor: {
    "@id": BUSINESS_ID,
  },
});

export const buildBookingJsonLd = () => ({
  "@type": "ContactPage",
  name: "Boka fotografering",
  description: "Boka en fotografering med Ina Nederdal i Stockholm. Porträtt, lifestyle, gravidfoto, familj och bröllop.",
  url: getCanonicalUrl("/booking"),
  mainEntity: {
    "@id": BUSINESS_ID,
  },
});

export const buildWorkJsonLd = ({ items = [] } = {}) => {
  if (items.length === 0) {
    return undefined;
  }

  return {
    "@type": "CollectionPage",
    name: "Portfolio - Ina Nederdal",
    description: "Se Ina Nederdals portfolio med porträtt-, lifestyle- och redaktionell fotografering från Stockholm.",
    url: getCanonicalUrl("/work"),
    mainEntity: {
      "@type": "ItemList",
      itemListElement: toListItems(items),
    },
  };
};

export const buildCategoryJsonLd = ({ categorySlug, categoryName, items = [] } = {}) => {
  if (items.length === 0) {
    return undefined;
  }

  const resolvedName = normalizeText(categoryName) || slugToLabel(categorySlug) || "Portfolio";

  return {
    "@type": "CollectionPage",
    name: `${resolvedName} - Portfolio`,
    description: `Se ${resolvedName}-fotografering av Ina Nederdal.`,
    url: getCanonicalUrl(`/work/${categorySlug}`),
    mainEntity: {
      "@type": "ItemList",
      itemListElement: toListItems(items),
    },
  };
};

export const buildJobJsonLd = ({
  categorySlug,
  categoryName,
  jobSlug,
  jobTitle,
  description,
  imageUrls = [],
} = {}) => {
  if (!jobTitle || !categorySlug || !jobSlug) {
    return undefined;
  }

  const resolvedCategoryName = normalizeText(categoryName) || slugToLabel(categorySlug);
  const pageUrl = getCanonicalUrl(`/work/${categorySlug}/${jobSlug}`);

  return [
    {
      "@type": "CreativeWork",
      name: jobTitle,
      description: normalizeText(description) || `${jobTitle} - fotografering av Ina Nederdal`,
      url: pageUrl,
      creator: {
        "@id": BUSINESS_ID,
      },
      author: {
        "@id": PERSON_ID,
      },
      image: imageUrls.slice(0, 10),
      thumbnailUrl: imageUrls[0],
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Hem",
          item: BASE_URL,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: resolvedCategoryName,
          item: getCanonicalUrl(`/work/${categorySlug}`),
        },
        {
          "@type": "ListItem",
          position: 3,
          name: jobTitle,
          item: pageUrl,
        },
      ],
    },
  ];
};

export const buildHejMammaJsonLd = ({ imageUrls = [] } = {}) => {
  const serviceImages = imageUrls.length > 0 ? imageUrls.slice(0, 10) : HEJ_MAMMA_FIXED_IMAGES;
  const pageUrl = getCanonicalUrl("/hej-mamma");

  return [
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Hem",
          item: BASE_URL,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Hej Mamma",
          item: pageUrl,
        },
      ],
    },
    {
      "@type": "Service",
      "@id": `${pageUrl}/#service`,
      mainEntityOfPage: pageUrl,
      name: "Hej Mamma! Gravidfoto & Mammaporträtt av Ina Nederdal",
      description:
        "Mammaporträtt i Stockholm. För dig som väntar barn, har en bebis, eller vill ha bilder med dina barn. Gravidfoto, mamma & barn, eller hela familjen. Paket från 4 200 kr, med 15% rabatt för självstående mammor.",
      url: pageUrl,
      image: serviceImages,
      provider: {
        "@id": BUSINESS_ID,
        "@type": "LocalBusiness",
      },
      areaServed: {
        "@type": "Place",
        name: "Stockholm, Sweden",
      },
      serviceType: [
        "Gravidfotografering",
        "Gravidfoto",
        "Gravidfotograf",
        "Mammaporträtt",
        "Mammaporträtt Stockholm",
        "Familjefotografering",
        "Familjefotograf",
        "Nyföddfotografering",
      ],
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        url: getCanonicalUrl("/booking"),
        priceSpecification: {
          "@type": "PriceSpecification",
          minPrice: 4200,
          priceCurrency: "SEK",
        },
      },
    },
    {
      "@type": "FAQPage",
      mainEntityOfPage: pageUrl,
      name: "Vanliga frågor om mammaporträtt och gravidfoto",
      author: {
        "@id": PERSON_ID,
      },
      mainEntity: toFaqItems(HEJ_MAMMA_FAQ_ITEMS),
    },
  ];
};

export const buildWeddingJsonLd = ({ imageUrls = [] } = {}) => {
  const pageUrl = getCanonicalUrl("/brollopsfotograf");

  return [
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Hem",
          item: BASE_URL,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Bröllop",
          item: pageUrl,
        },
      ],
    },
    {
      "@type": "Service",
      "@id": `${pageUrl}/#service`,
      mainEntityOfPage: pageUrl,
      name: "Bröllopsfotograf i Stockholm | Ina Nederdal",
      description:
        "Bröllopsfotograf i dokumentär stil som fångar helheten: porträtt, vigsel, tårar och dansgolv. Bas i Stockholm, reser gärna.",
      url: pageUrl,
      image: dedupe([...WEDDING_FEATURED_IMAGES, ...imageUrls.slice(0, 10)]),
      provider: {
        "@id": BUSINESS_ID,
        "@type": "LocalBusiness",
      },
      areaServed: {
        "@type": "Place",
        name: "Stockholm, Sweden",
      },
      serviceType: ["Bröllopsfotograf", "Bröllopsfotograf Stockholm", "Dokumentär bröllopsfotograf"],
      offers: [
        {
          "@type": "Offer",
          name: "Bröllopsfoto 2 timmar",
          price: "14000",
          priceCurrency: "SEK",
          availability: "https://schema.org/InStock",
        },
        {
          "@type": "Offer",
          name: "Bröllopsfoto 3 timmar",
          price: "18000",
          priceCurrency: "SEK",
          availability: "https://schema.org/InStock",
        },
        {
          "@type": "Offer",
          name: "Halvdag bröllopsfoto 5 timmar",
          price: "25000",
          priceCurrency: "SEK",
          availability: "https://schema.org/InStock",
        },
        {
          "@type": "Offer",
          name: "Dag bröllopsfoto 8 timmar",
          price: "34000",
          priceCurrency: "SEK",
          availability: "https://schema.org/InStock",
        },
        {
          "@type": "Offer",
          name: "Heldag bröllopsfoto 10 timmar",
          price: "42000",
          priceCurrency: "SEK",
          availability: "https://schema.org/InStock",
        },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntityOfPage: pageUrl,
      name: "Vanliga frågor om bröllopsfotografering",
      mainEntity: toFaqItems(WEDDING_FAQ_ITEMS),
    },
  ];
};
